import { createReducer, on } from '@ngrx/store';
import {
  setEntityRole,
  setRole,
  setRolePermissions,
  setRolePermissionsLoading,
} from '../actions/role.actions';
import {
  RolePermission,
  UserRole,
} from '@shared/interfaces/permissions.interface';

export const roleFeatureKey = 'role';

export interface RoleState {
  role?: UserRole;
  entityRoles: {
    [entityId: string]: UserRole;
  };
  rolePermissions: {
    [roleId: string]: RolePermission[];
  };
  loading: {
    [roleId: string]: boolean;
  };
}

export const initialState: RoleState = {
  role: undefined,
  entityRoles: {},
  rolePermissions: {},
  loading: {},
};

export const roleReducer = createReducer(
  initialState,
  on(setRole, (state, { role }) => ({
    ...state,
    role,
  })),
  on(setEntityRole, (state, { entityId, role }) => ({
    ...state,
    entityRoles: {
      ...state.entityRoles,
      [entityId]: role,
    },
  })),
  on(setRolePermissions, (state, { roleId, permissions }) => ({
    ...state,
    rolePermissions: {
      ...state.rolePermissions,
      [roleId]: permissions,
    },
    loading: {
      ...state.loading,
      [roleId]: false,
    },
  })),
  on(setRolePermissionsLoading, (state, { roleId, loading }) => ({
    ...state,
    loading: {
      ...state.loading,
      [roleId]: loading,
    },
  })),
);
